<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Right",
  data: () => ({
    drawer: null,
  }),
  watch: {
    $route() {
      $("#navbarCollapse").collapse("hide");
    },
  },
};
</script>
